/**
 * Long enough to read, short enough that it is gone before the next scan lands [SSD-7215]. Only a card the desk
 * can miss without harm has this clock (`dismissal: 'auto'`): a success, a nudge about the click just made, the
 * Scan the shelf reminder. A card saying something did not happen stays until it is closed (SSD-7705). Kept apart
 * from the component so a module without React (gtoast) can share the clock.
 */
export const FULFILLMENT_TOAST_MS = 6000;
